import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

// v3.0.0-rc.5 — Phase Quick Wins J1 : Sentry frontend (no-op gracieux si DSN absent).
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || "development",
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.1"),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
    initialScope: { tags: { service: "aya-frontend" } },
  });
  // eslint-disable-next-line no-console
  console.info("[sentry] frontend initialized");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
// v2.0.0 — StrictMode désactivé : react-leaflet@4 est incompatible avec le
// double-mount/unmount de StrictMode en dev (Map container is already initialized).
// Cf. https://github.com/PaulLeCam/react-leaflet/issues/1133
root.render(<App />);

// v3.0.0-rc.8z-pwa — Enregistre le Service Worker + hooks install/update.
// Après render() pour ne jamais bloquer le premier paint.
if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_ENABLE_PWA_DEV === '1') {
  // eslint-disable-next-line global-require
  const { registerServiceWorker } = require('@/pwa/registerSW');
  registerServiceWorker();
}
